import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBatchRatingResults extends Layout {
    sourceBrokerageMovements: DataSource;
    tableResults: Table;
}
